import "react-quill/dist/quill.snow.css";
import React, { useState } from "react";
import { Col, Row, Modal } from "antd";

import MainLayout from "components/MainLayout";
import { useParams } from "react-router-dom";
import { useIssueKinds } from "context/providers/issue_kinds";
import IssueKindProblems from "./components/IssueKindProblems";
import { useAuth } from "context/providers/auth";
import Info from "./components/Info";
import BasicInfo from "./components/BasicInfo";
import DangerInfo from "./components/DangerInfo";
import Icon from "./components/Icon";

const IssueKindEdit = () => {
  const { id } = useParams();
  const {
    state: {
      user: { company },
    },
  } = useAuth();
  const { data, refetch } = useIssueKinds();
  const [is_open_preview_modal, setOpenPreviewModal] = useState();
  const issue_kind = data.find((item) => item.id === id);

  return (
    <MainLayout
      back_href="/settings"
      breadcrumbs={[
        { name: "Ustawienia", path: "/settings" },
        { name: "Rodzaj zgłoszenia" },
      ]}
    >
      {is_open_preview_modal && (
        <Modal
          title={issue_kind.name}
          centered
          width="100%"
          open={true}
          onOk={() => setOpenPreviewModal(false)}
          onCancel={() => setOpenPreviewModal(false)}
        >
          <iframe
            style={{ width: "100%", height: "80vh" }}
            title={issue_kind.name}
            src={`https://evertask.pl/${company?.slug}/zgloszenia/${id}`}
            frameborder="0"
          />
        </Modal>
      )}
      <Row gutter={[24, 24]}>
        <Col xs={24} md={24} lg={24} xl={12}>
          <BasicInfo setOpenPreviewModal={setOpenPreviewModal} />
          <Icon />
        </Col>
        <Col xs={24} md={24} lg={24} xl={12}>
          <IssueKindProblems
            issue_kind_id={id}
            data={issue_kind?.issue_kind_problems}
            refetch={refetch}
          />
          <Info />
          <DangerInfo />
        </Col>
      </Row>
      <Row gutter={[24, 24]} className="m-t-20 m-b-20">
        <Col xs={24} md={24} lg={24} xl={12}></Col>
        <Col xs={24} md={24} lg={24} xl={12}></Col>
      </Row>
    </MainLayout>
  );
};

export default IssueKindEdit;
